import React, { useCallback, useState } from "react";
// @ts-ignore
import { Helmet, HelmetProvider } from "react-helmet-async";
import { createUseStyles } from "react-jss";
import { ThemeType } from "../styles/theme";
import { servicePolicyVersions } from "../components/Common/servicePolicy";
import { privacyPolicyVersions } from "../components/Common/privacyPolicy";

const useStyles = createUseStyles((theme: ThemeType) => ({
   wrap: {
      width: "100%",
   },
   policyContainer: {
      width: `calc(100% - ${theme.gap * 2}px)`,
      margin: "0 auto",
      padding: "20px 0",
   },
   versionList: {
      marginTop: 30,
      borderTop: "1px solid #eee",
      paddingTop: 20,
   },
   versionItem: {
      padding: "10px 15px",
      margin: "5px 0",
      borderRadius: 4,
      cursor: "pointer",
      transition: "background-color 0.2s",
      "&:hover": {
         backgroundColor: "#f5f5f5",
      },
   },
   activeVersion: {
      backgroundColor: "#f0f0f0",
      fontWeight: "bold",
   },
   policyContent: {
      marginTop: 20,
   },
   latestBadge: {
      display: "inline-block",
      marginLeft: 10,
      padding: "2px 8px",
      backgroundColor: "#4CAF50",
      color: "white",
      borderRadius: 12,
      fontSize: "0.75rem",
   },
}));

interface PolicyPageProps {
   policyType: "service" | "privacy";
}

const PolicyPage: React.FC<PolicyPageProps> = ({ policyType }) => {
   const classes = useStyles();
   const policyVersions =
      policyType === "service" ? servicePolicyVersions : privacyPolicyVersions;
   const pageTitle =
      policyType === "service" ? "서비스 이용약관" : "개인정보 처리방침";

   const [selectedIdx, setIdx] = useState<number>(0);
   const toggleItem = useCallback(
      (idx: number) => {
         setIdx(selectedIdx !== idx ? idx : -1);
      },
      [selectedIdx]
   );
   const currentPolicy = policyVersions[selectedIdx];

   return (
      <>
         <HelmetProvider>
            <Helmet>
               <title>{pageTitle}</title>
            </Helmet>
         </HelmetProvider>
         <div className={classes.wrap}>
            <div className={classes.policyContainer}>
               <div
                  className={classes.policyContent}
                  dangerouslySetInnerHTML={{ __html: currentPolicy.content }}
               />

               <div className={classes.versionList}>
                  {policyVersions.map((policy, idx) => (
                     <div
                        key={policy.date}
                        className={`${classes.versionItem} ${
                           selectedIdx === idx ? classes.activeVersion : ""
                        }`}
                        onClick={() => toggleItem(idx)}
                     >
                        {policy.date}
                     </div>
                  ))}
               </div>
            </div>
         </div>
      </>
   );
};

// 서비스 이용약관을 위한 래퍼 컴포넌트
export const ServicePage = () => <PolicyPage policyType="service" />;

// 개인정보 처리방침을 위한 래퍼 컴포넌트
export const PrivacyPolicyPage = () => <PolicyPage policyType="privacy" />;
